import {useTitle} from 'hooks';
import {useParams} from 'react-router-dom';
import {Transitioner} from 'components';

import BillingMine from './components/Billing.Mine';

interface IPageBillingProps {}

const PageBilling = ({}: IPageBillingProps) => {
  useTitle('Billing');

  const params = useParams();
  const workspace = params.workspace ?? '';
  const resource = params.resource ?? '';

  if (workspace === 'me') {
    return <BillingMine />;
  }

  return (
    <Transitioner key={`/${workspace}/${resource}`}>
      <h1>BILLING</h1>
    </Transitioner>
  );
};

export default PageBilling;
